import React from 'react';

const getVoiceSpeed = (durationSeconds) => {
  if (durationSeconds >= 75) return '1.05s';
  if (durationSeconds >= 35) return '1.24s';
  if (durationSeconds >= 12) return '1.42s';
  return '1.72s';
};

const VoiceVisual = ({ revealMeta = {} }) => {
  const voiceState = revealMeta.voiceState || {};
  const hasAudio = Boolean(voiceState.hasAudio);
  const durationSeconds = Number(voiceState.durationSeconds || 0);
  const barCount = hasAudio ? 20 : 14;
  const durationEnergy = Math.min(1.45, Math.max(0.72, durationSeconds ? durationSeconds / 38 : 0.72));

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-voice ${hasAudio ? 'has-audio' : 'is-empty'}`}
      style={{
        '--voice-speed': getVoiceSpeed(durationSeconds),
        '--voice-energy': durationEnergy,
      }}
      aria-hidden="true"
    >
      <span className="pulse-ring" />
      <span className="capsule">
        {Array.from({ length: barCount }, (_, index) => {
          const pattern = hasAudio ?
            [0.72, 1.15, 0.86, 1.36, 0.98, 1.52, 0.88, 1.24] :
            [0.38, 0.58, 0.44, 0.62, 0.5, 0.42, 0.56];
          const height = pattern[index % pattern.length] * durationEnergy;
          return (
            <i
              key={index}
              style={{
                '--bar-x': `${1.18 + index * (hasAudio ? 0.52 : 0.68)}rem`,
                '--bar-height': `${Math.min(2.35, Math.max(0.42, height))}rem`,
                '--bar-delay': `${index * (hasAudio ? 44 : 88)}ms`,
              }}
            />
          );
        })}
      </span>
      <span className="play" />
      <small className="voice-status">
        {hasAudio ? (voiceState.durationLabel || 'Voice saved') : 'Ready to record'}
      </small>
    </span>
  );
};

export default VoiceVisual;
